export const SACRA_GAME_HERO_CHOOSE_FAV = 'SACRA_GAME_HERO_CHOOSE_FAV';
export const SACRA_GAME_SELECTED_HERO = 'SACRA_GAME_SELECTED_HERO';
